// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/issue-view/issue-view.component.css
// module id = 748
// module chunks = 0